export default {
  "achievement_title": {
    "HK": "成就",
    "TW": "成就",
    "ar_SA": "الإنجازات",
    "de_DE": "Achievements",
    "en_US": "Achievements",
    "es_ES": "Logros",
    "fr_FR": "Succès",
    "hi_IN": "Achievements",
    "in_ID": "Prestasi",
    "ja_JP": "Achievements",
    "ko_KR": "Achievements",
    "ms_MY": "Pencapaian",
    "pt_PT": "Conquistas",
    "ru_RU": "Достижения",
    "th_TH": "ความสำเร็จ",
    "tr_TR": "Başarımlar",
    "ur": "‏کامیابیاں",
    "uz": "Yutuqlar",
    "vi_VN": "Thành tích",
    "zh_CN": "成就"
  },
  "club_achievement_1": {
    "HK": "恭喜你！你建立的俱樂部%s達到%s成員成就！",
    "TW": "恭喜您！您建立的俱樂部%s達成%s成員成就！",
    "ar_SA": "تهانينا! وصل النادي%s الذي أنشأته إلى تحرير الإنجازات لتحقيق %s من الأعضاء!",
    "de_DE": "Herzlichen Glückwunsch! Der von dir gegründete Club %s hat das Achievement für „%s Mitglieder“ freigeschaltet!",
    "en_US": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "es_ES": "¡Felicidades! ¡El club que creaste, %s, ha desbloqueado el logro por llegar a %s miembros!",
    "fr_FR": "Félicitations ! Le club que vous avez créé, %s, a débloqué le succès pour avoir atteint %s membres !",
    "hi_IN": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "in_ID": "Selamat! Klub yang kamu buat, %s, telah membuka prestasi setelah mencapai %s anggota!",
    "ja_JP": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "ko_KR": "Congratulations! The club you created, %s, has unlocked the achievement for reaching %s members!",
    "ms_MY": "Tahniah! Kelab yang anda cipta iaitu %s telah membuka pencapaian kerana mencapai %s ahli!",
    "pt_PT": "Parabéns! O clube que você criou, %s, desbloqueou a conquista por alcançar %s membros!",
    "ru_RU": "Поздравляем! В вашем клубе «%s» уже %s участников! Открыто достижение!",
    "th_TH": "ยินดีด้วย! คลับ %s ที่คุณสร้างปลดล็อคความสำเร็จเนื่องจากมีสมาชิกครบ %s คน!",
    "tr_TR": "Tebrikler! Oluşturduğun %s kulübü, %s oyuncuya ulaşarak başarım kazandı!",
    "ur": "مبارک ہو! آپ کے تخلیق کردہ کلب، %s، نے %s ممبرز تک پہنچنے کی کامیابی ان لاک کر لی ہے!",
    "uz": "Tabriklaymiz! Siz yaratgan %s klubi %s ta aʼzoga yetganlik uchun yutuq ochdi!",
    "vi_VN": "Xin chúc mừng! Câu Lạc Bộ %s do bạn sáng lập đã đạt %s thành viên!",
    "zh_CN": "恭喜你！你创建的俱乐部%s达到了%s成员成就！"
  },
  "club_achievement_2": {
    "HK": "恭喜你！解鎖了新建俱樂部成就：%s ！",
    "TW": "恭喜您！解鎖了建立新俱樂部成就：%s！",
    "ar_SA": "تهانينا! تم تحرير إنجاز إنشاء النادي الجديد: %s!",
    "de_DE": "Glückwunsch! Du hast das neue Clubgründungs-Achievement: %s freigeschaltet!",
    "en_US": "Congratulations! Unlocked the new club creation achievement: %s!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el nuevo logro de creación de clubes: %s!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès de création de club : %s !",
    "hi_IN": "Congratulations! Unlocked the new club creation achievement: %s!",
    "in_ID": "Selamat! Pencapaian klub baru dibuka: %s!",
    "ja_JP": "Congratulations! Unlocked the new club creation achievement: %s!",
    "ko_KR": "Congratulations! Unlocked the new club creation achievement: %s!",
    "ms_MY": "Tahniah! Anda membuka pencapaian ciptaan kelab baharu: %s!",
    "pt_PT": "Parabéns! Desbloqueou a conquista de criação de novo clube: %s!",
    "ru_RU": "Поздравляем с достижением за создание клуба «%s»!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จการสร้างคลับใหม่: %s!",
    "tr_TR": "Tebrikler! Yeni kulüp oluşturma başarımını kazandın: %s!",
    "ur": "مبارک ہو! نئے کلب کی تخلیق کی کامیابی ان لاک ہو گئی ہے: %s!",
    "uz": "Tabriklaymiz! Klub yaratishning yangi yutugʻi ochildi: %s!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích sáng lập Câu Lạc Bộ Mới: %s!",
    "zh_CN": "恭喜你！解锁了新建俱乐部成就：%s ！"
  },
  "club_achievement_3": {
    "HK": "恭喜你！解鎖了動態發佈獲得讚好總數%s成就！",
    "TW": "恭喜您！解鎖了動態發佈獲得按讚總數%s成就！",
    "ar_SA": "تهانينا! تم تحرير الإنجاز لبلوغ %s من إجمالي الإعجابات للمنشور!",
    "de_DE": "Glückwunsch! Du hast das Achievement fürs Erreichen von %s Gesamt-LIKEs für Beiträge freigeschaltet!",
    "en_US": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el logro por alcanzar %s ME GUSTA en publicaciones!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès pour avoir reçu un total de %s LIKES sur vos billets !",
    "hi_IN": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "in_ID": "Selamat! Berhasil membuka prestasi setelah mencapai %s total LIKE postingan!",
    "ja_JP": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "ko_KR": "Congratulations! Unlocked the achievement for reaching %s total post LIKEs!",
    "ms_MY": "Tahniah! Anda membuka pencapaian kerana mencapai sejumlah %s SUKA siaran!",
    "pt_PT": "Parabéns! Desbloqueou a conquista por atingir o total de %s CURTIDAS de postagens!",
    "ru_RU": "Поздравляем с достижением! Вы получили %s лайков за сообщения!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จเนื่องจากมียอดไลก์โพสต์รวมครบ %s!",
    "tr_TR": "Tebrikler! Paylaşımlarının toplamda %s beğeniye ulaşma başarımını kazandın!",
    "ur": "مبارک ہو! پوسٹ کے کُل %s لائکس تک پہنچنے کی کامیابی ان لاک ہو گئی ہے!",
    "uz": "Tabriklaymiz! Postlarda jami %s ta Layk olgani uchun yutuq ochildi!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích đạt %s lượt THÍCH cho các bài đăng!",
    "zh_CN": "恭喜你！解锁了动态发布获赞总数%s成就！"
  },
  "club_achievement_4": {
    "HK": "恭喜你！解鎖了動態發佈%s篇成就！",
    "TW": "恭喜您！解鎖了動態發佈%s篇成就！",
    "ar_SA": "تهانينا! تم تحرير الإنجاز لبلوغ إجمالي %s من المشاركات!",
    "de_DE": "Glückwunsch! Du hast das Achievement fürs Erreichen von %s Gesamt-Beiträgen freigeschaltet!",
    "en_US": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "es_ES": "¡Felicidades! ¡Desbloqueaste el logro por alcanzar %s publicaciones totales!",
    "fr_FR": "Félicitations ! Vous avez débloqué le succès pour avoir publié %s billets !",
    "hi_IN": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "in_ID": "Selamat! Berhasil membuka prestasi setelah mencapai total %s postingan!",
    "ja_JP": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "ko_KR": "Congratulations! Unlocked the achievement for reaching %s total posts!",
    "ms_MY": "Tahniah! Anda membuka pencapaian kerana mencapai sejumlah %s siaran!",
    "pt_PT": "Parabéns! Desbloqueou a conquista por atingir o total de %s postagens!",
    "ru_RU": "Поздравляем с достижением! Вы написали %s сообщений!",
    "th_TH": "ยินดีด้วย! ปลดล็อคความสำเร็จเนื่องจากจำนวนโพสต์รวมครบ %s!",
    "tr_TR": "Tebrikler! Toplamda %s paylaşıma ulaşma başarımını kazandın!",
    "ur": "مبارک ہو! کُل %s پوسٹس تک پہنچنے کی کامیابی ان لاک ہو گئی ہے!",
    "uz": "Tabriklaymiz! Jami %s ta postga erishish uchun yutuq ochildi!",
    "vi_VN": "Xin chúc mừng! Bạn đã mở khóa thành tích đạt %s bài đăng!",
    "zh_CN": "恭喜你！解锁了动态发布%s篇成就！"
  },
  "club_achievement_5": {
    "HK": "恭喜你！你發佈的「%s」解鎖了%s讚好成就！",
    "TW": "恭喜您！您發佈的「%s」解鎖了%s按讚成就！",
    "ar_SA": "تهانينا! حرر منشورك \"%s\" للتو الإنجاز لبلوغ %s من الإعجابات!",
    "de_DE": "Glückwunsch! Dein Beitrag „%s“ hat soeben das Achievement für das Erreichen von %s LIKEs freigeschaltet!",
    "en_US": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "es_ES": "¡Felicidades! ¡Tu publicación, \"%s\", acaba de desbloquear el logro por alcanzar %s ME GUSTA!",
    "fr_FR": "Félicitations ! Votre billet, %s, a débloqué le succès pour avoir reçu %s LIKES !",
    "hi_IN": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "in_ID": "Selamat! Postingan kamu, \"%s\", baru saja membuka prestasi setelah mencapai %s SUKA!",
    "ja_JP": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "ko_KR": "Congratulations! Your post, \"%s,\" just unlocked the achievement for reaching %s LIKEs!",
    "ms_MY": "Tahniah! Siaran anda iaitu \"%s\" baru membuka pencapaian kerana mencapai %s SUKA!",
    "pt_PT": "Parabéns! Sua postagem, \"%s\", acabou de desbloquear a conquista por alcançar %s CURTIDAS!",
    "ru_RU": "Поздравляем с достижением! Ваше сообщение «%s» получило %s лайков!",
    "th_TH": "ยินดีด้วย! โพสต์ \"%s\" ของคุณเพิ่งปลดล็อคความสำเร็จเนื่องจากมียอดไลก์ครบ %s!",
    "tr_TR": "Tebrikler! \"%s\" paylaşımın %s beğeniye ulaşarak yeni bir başarım kazandı!",
    "ur": "مبارک ہو! آپ کی پوسٹ، \"%s،\" نے ابھی ابھی %s لائکس تک پہنچنے کی کامیابی ان لاک کر لی ہے!",
    "uz": "Tabriklaymiz! “%s” postingiz %s ta Layk olgani uchun yutuq ochildi!",
    "vi_VN": "Xin chúc mừng! Bài đăng của bạn \"%s\" đã mở khóa thành tích đạt %s lượt THÍCH!",
    "zh_CN": "恭喜你！你发布的“%s”解锁了%s点赞成就！"
  },
  "club_achievement_6": {
    "HK": "恭喜你！你獲得了%s珍貴勳章！",
    "TW": "恭喜您！您獲得了%s珍貴勳章！",
    "ar_SA": "تهانينا! حصلت على شارة قيِّمة: %s!",
    "de_DE": "Glückwunsch! Du hast das folgende wertvolle Abzeichen erhalten: %s",
    "en_US": "Congratulations! You got the valuable Badge: %s!",
    "es_ES": "Congratulations! You got the valuable Badge: %s!",
    "fr_FR": "Félicitations ! Vous avez obtenu le précieux insigne : %s !",
    "hi_IN": "Congratulations! You got the valuable Badge: %s!",
    "in_ID": "Selamat! Kamu mendapatkan Lencana yang berharga: %s!",
    "ja_JP": "Congratulations! You got the valuable Badge: %s!",
    "ko_KR": "Congratulations! You got the valuable Badge: %s!",
    "ms_MY": "Tahniah! Anda mendapat Lencana bernilai: %s!",
    "pt_PT": "Parabéns! Você recebeu o valioso Emblema: %s!",
    "ru_RU": "Поздравляем! Вы получили эмблему «%s»!",
    "th_TH": "ยินดีด้วย! คุณได้รับตราประทับที่ล้ำค่า: %s!",
    "tr_TR": "Tebrikler! Değerli bir Rozet kazandın: %s!",
    "ur": "مبارک ہو! آپ نے گراں قدر بیج حاصل کر لیا ہے: %s!",
    "uz": "Tabriklaymiz! Qimmatbaho nishon oldingiz: %s!",
    "vi_VN": "Xin chúc mừng! Bạn nhận được Huy Hiệu giá trị: %s!",
    "zh_CN": "恭喜你！你获得了%s珍贵勋章！"
  },
  "club_achievement_club": {
    "HK": "俱樂部成就",
    "TW": "俱樂部成就",
    "ar_SA": "إنجازات النادي",
    "de_DE": "Club-Achievements",
    "en_US": "Club Achievements",
    "es_ES": "Logros del Club",
    "fr_FR": "Succès de club",
    "hi_IN": "Club Achievements",
    "in_ID": "Prestasi Klub",
    "ja_JP": "Club Achievements",
    "ko_KR": "Club Achievements",
    "ms_MY": "Pencapaian Kelab",
    "pt_PT": "Conquistas de Clube",
    "ru_RU": "Достижения клуба",
    "th_TH": "ความสำเร็จคลับ",
    "tr_TR": "Kulüp Başarımları",
    "ur": "کلب کی کامیابیاں",
    "uz": "Klub yutuqlari",
    "vi_VN": "Thành Tích Câu Lạc Bộ",
    "zh_CN": "俱乐部成就"
  },
  "club_achievement_current_progress": {
    "HK": "目前進度",
    "TW": "目前進度",
    "ar_SA": "التقدم الحالي",
    "de_DE": "Aktueller Fortschritt",
    "en_US": "Current Progress",
    "es_ES": "Progreso actual",
    "fr_FR": "Progression",
    "hi_IN": "Current Progress",
    "in_ID": "Progres Saat Ini",
    "ja_JP": "Current Progress",
    "ko_KR": "Current Progress",
    "ms_MY": "Kemajuan Semasa",
    "pt_PT": "Progresso Atual",
    "ru_RU": "Текущий прогресс",
    "th_TH": "ความก้าวหน้าขณะนี้",
    "tr_TR": "Mevcut İlerleme",
    "ur": "موجودہ پیشرفت",
    "uz": "Joriy rivoj",
    "vi_VN": "Tiến Độ Hiện Tại",
    "zh_CN": "目前进度"
  },
  "club_achievement_list_title": {
    "HK": "里程碑",
    "TW": "里程碑",
    "ar_SA": "الإنجاز",
    "de_DE": "Meilenstein",
    "en_US": "Milestone",
    "es_ES": "Hitos",
    "fr_FR": "Seuil",
    "hi_IN": "Milestone",
    "in_ID": "Milestone",
    "ja_JP": "Milestone",
    "ko_KR": "Milestone",
    "ms_MY": "Titik Capai",
    "pt_PT": "Marco",
    "ru_RU": "Цели",
    "th_TH": "ไมล์สโตน",
    "tr_TR": "Hedef",
    "ur": "سنگ میل",
    "uz": "Marra",
    "vi_VN": "Mốc",
    "zh_CN": "里程碑"
  },
  "club_achievement_medal": {
    "HK": "勳章成就",
    "TW": "勳章成就",
    "ar_SA": "إنجازات الشارة",
    "de_DE": "Abzeichen-Achievement",
    "en_US": "Badge Achievement",
    "es_ES": "Badge Achievement",
    "fr_FR": "Succès d'insignes",
    "hi_IN": "Badge Achievement",
    "in_ID": "Prestasi Lencana",
    "ja_JP": "Badge Achievement",
    "ko_KR": "Badge Achievement",
    "ms_MY": "Pencapaian Lencana",
    "pt_PT": "Conquista de Emblema",
    "ru_RU": "Эмблема за достижения",
    "th_TH": "ความสำเร็จตราประทับ",
    "tr_TR": "Rozet Başarımı",
    "ur": "کامیابی کا بیج",
    "uz": "Nishon yutugʻi",
    "vi_VN": "Thành Tích Huy Hiệu",
    "zh_CN": "勋章成就"
  },
  "club_achievement_next_level": {
    "HK": "下一等級",
    "TW": "下一等級",
    "ar_SA": "المستوى التالي",
    "de_DE": "Nächster Level",
    "en_US": "Next Level",
    "es_ES": "Siguiente Nivel",
    "fr_FR": "Niveau suivant",
    "hi_IN": "Next Level",
    "in_ID": "Level Selanjutnya",
    "ja_JP": "Next Level",
    "ko_KR": "Next Level",
    "ms_MY": "Tahap Seterusnya",
    "pt_PT": "Nível Seguinte",
    "ru_RU": "Следующий уровень",
    "th_TH": "เลเวลต่อไป",
    "tr_TR": "Sonraki Seviye",
    "ur": "‏اگلا لیول",
    "uz": "Keyingi daraja",
    "vi_VN": "Cấp Tiếp Theo",
    "zh_CN": "下一等级"
  },
  "club_achievement_overview_close": {
    "HK": "收起",
    "TW": "收起",
    "ar_SA": "طي",
    "de_DE": "Einklappen",
    "en_US": "Collapse",
    "es_ES": "Contraer",
    "fr_FR": "Réduire",
    "hi_IN": "Collapse",
    "in_ID": "Tutup",
    "ja_JP": "Collapse",
    "ko_KR": "Collapse",
    "ms_MY": "Ranap",
    "pt_PT": "Minimizar",
    "ru_RU": "Свернуть",
    "th_TH": "ย่อ",
    "tr_TR": "Daralt",
    "ur": "‏تصادم",
    "uz": "Yigʻish",
    "vi_VN": "Thu gọn",
    "zh_CN": "收起"
  },
  "club_achievement_overview_condition_10": {
    "HK": "在俱樂部內，在日曆月內發佈帖文獲得讚好數目達到1,000，每月更新可重複完成。任何異常帳號的讚好不會計作有效進度。",
    "TW": "在俱樂部內，當月發文獲得按讚數達到1,000。任務每月更新，可重複完成。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 1000 إعجاب من المنشورات في النادي في شهر ميلادي. يمكن إكمالها كل شهر. لن يتم احتساب أي إعجابات من حسابات غير طبيعية.",
    "de_DE": "Erhalte 1000 LIKEs durch Beiträge im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden. LIKEs von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "es_ES": "Obtén 1000 ME GUSTA en comentarios en el Club en un mes calendario. Se puede completar cada mes. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Obtenez 1 000 LIKES sur vos billets dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois. Les LIKES provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "in_ID": "Dapatkan 1.000 LIKE dari postinganmu di Club dalam satu bulan kalender. Bisa dilakukan setiap bulan. LIKE dari akun abnormal tidak akan dihitung.",
    "ja_JP": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "ko_KR": "Get 1,000 LIKEs from posts in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 1,000 LIKE daripada siaran di Kelab dalam sebulan. Boleh diselesaikan setiap bulan. Sebarang LIKE daripada akaun abnormal tidak dikira.",
    "pt_PT": "Receba 1.000 CURTIDAs de publicações no Clube em um mesmo mês. Pode ser concluída a cada mês. CURTIDAs de contas anormais não contam.",
    "ru_RU": "Получите 1000 лайков за публикации в клубе в течение календарного месяца. Можно достигать каждый месяц. Лайки от подозрительных аккаунтов не учитываются.",
    "th_TH": "ได้รับ 1,000 ไลก์ จากโพสต์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน สามารถบรรลุได้ทุกเดือน โดยจะไม่นับรวมไลก์ที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki paylaşımlarına 1,000 beğeni al. Her ay tamamlanabilir. Anormal hesaplardan verilen beğeniler hesaba katılmaz.",
    "ur": "کیلنڈر مہینے میں کلب میں پوسٹس سے 1,000 لائیکس حاصل کریں۔ ہر مہینے مکمل کیا جا سکتا ہے۔ غیر معمولی اکاؤنٹس سے ملنے والے کوئی بھی لائیکس شمار نہیں ہوتے۔",
    "uz": "Bir kalendar oyida Klubdagi postlardan 1000 ta Layk oling. Har oyda bajarilishi mumkin. Noodatiy akkauntlardan bosilgan Layklar hisobga olinmaydi.",
    "vi_VN": "Các bài đăng trong Câu Lạc Bộ nhận tổng cộng 1,000 lượt THÍCH trong tháng. Có thể hoàn thành mỗi tháng. Những lượt THÍCH đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，自然月发帖获得的赞数达到1,000，每月更新可重复完成。任何异常账号的点赞行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_11": {
    "HK": "在俱樂部內，累積獲得1,000名追蹤者。僅計算新增追蹤者人數，最初互相追蹤的遊戲好友人數不會計入成就進度。任何異常帳號的追蹤不會計作有效進度。",
    "TW": "在俱樂部內，累計獲得1,000名追蹤者。僅統計新增追蹤者數量，初始互相追蹤的遊戲好友數量不會計入成就進度。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 1000 متابع في النادي. يُحتسب المتابعون الجدد فقط. لا يُحتسب العدد الأولي للأصدقاء في اللعبة ضمن تقدم الإنجاز. لن يتم احتساب أي متابعين من حسابات غير طبيعية.",
    "de_DE": "Erhalte 1000 Follower im Club. Es zählen nur neue Follower. Die anfängliche Anzahl bereits vorhandener Freunde trägt nicht zum Fortschritt des Achievements bei. Follower von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 1,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "es_ES": "Obtén 1000 seguidores en el Club. Solo cuentan los nuevos seguidores. El número inicial de amistades del juego en común no cuenta para el progreso de los logros. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Cumulez 1 000 abonnés dans le Club. Seuls les nouveaux abonnés sont comptabilisés. Le nombre initial d'amis mutuels en jeu n'est pas pris en compte dans la progression du succès. Les abonnements provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 1,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "in_ID": "Dapatkan 1.000 pengikut di Club. Sistem hanya menghitung pengikut baru. Teman dalam game yang saling mengikuti sejak awal tidak dihitung dalam progres pencapaian. Akun abnormal yang mengikutimu tidak akan dihitung.",
    "ja_JP": "Get 1,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ko_KR": "Get 1,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 1,000 Folllower di Kelab. Hanya Follower baharu yang akan dikira. Bilangan awal rakan yang mengikuti satu sama lain tidak diambil kira dalam kemajuan pencapaian. Sebarang Follow daripada akaun abnormal tidak dikira.",
    "pt_PT": "Obtenha 1.000 seguidores no Clube. Somente seguidores novos são contados. O número inicial de amigos mútuos no jogo não conta para o progresso da conquista. Seguidores com contas anormais não contam.",
    "ru_RU": "Наберите 1000 подписчиков в клубе. Учитываются только новые подписчики. Взаимные друзья по игре, которые добавились изначально, не учитываются при получении достижения. Подписки, оформленные с подозрительных аккаунтов, не учитываются.",
    "th_TH": "มีผู้ติดตามในคลับครบ 1,000 คน โดยจะนับแค่ผู้ติดตามใหม่เท่านั้น สำหรับจำนวนเพื่อนในเกมร่วมกันเริ่มต้นจะไม่ถูกนับรวมในความก้าวหน้าของความสำเร็จ โดยจะไม่นับรวมการติดตามที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Kulüp'te 1.000 takipçiye ulaş. Sadece yeni takipçiler hesaba katılır. Başlangıçta birbirini takip eden oyun arkadaşları başarım hesaplamasında dikkate alınmaz. Anormal hesaplardan gerçekleştirilen takipler hesaba katılmaz.",
    "ur": "کلب میں 1,000 فالورز حاصل کریں۔ صرف نئے فالورز کو شمار کیا جاتا ہے۔ گیم کے باہمی دوستوں کی ابتدائی تعداد کامیابی کی پیشرفت میں شمار نہیں ہوتی۔ غیر معمولی اکاؤنٹس کے کوئی بھی فالوز شمار نہیں ہوتے۔",
    "uz": "Klubda 1000 kuzatuvchi jalb qiling. Faqat yangi kuzatuvchilar hisobga olinadi. Bir-birini kuzatadigan do‘stlarning dastlabki soni yutuq rivoji uchun hisobga olinmaydi. Noodatiy akkauntlardan kuzatishlar hisobga olinmaydi.",
    "vi_VN": "Nhận 1,000 người theo dõi trong Câu Lạc Bộ. Chỉ tính người theo dõi mới. Số lượng bạn bè trò chơi theo dõi lẫn nhau ban đầu không được tính vào tiến trình thành tích. Những lượt theo dõi đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，累计获得1,000名关注者。仅统计新增关注者数量，初始互相关注的游戏好友数量不会进入成就进度。任何异常账号的关注行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_12": {
    "HK": "在俱樂部內，累積獲得100,000名追蹤者。僅計算新增追蹤者人數，最初互相追蹤的遊戲好友人數不會計入成就進度。任何異常帳號的追蹤不會計作有效進度。",
    "TW": "在俱樂部內，累計獲得100,000名追蹤者。僅統計新增追蹤者數量，初始互相追蹤的遊戲好友數量不會計入成就進度。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 100 ألف متابع في النادي. يُحتسب المتابعون الجدد فقط. لا يُحتسب العدد الأولي للأصدقاء في اللعبة ضمن تقدم الإنجاز. لن يتم احتساب أي متابعين من حسابات غير طبيعية.",
    "de_DE": "Erhalte 100000 Follower im Club. Es zählen nur neue Follower. Die anfängliche Anzahl bereits vorhandener Freunde trägt nicht zum Fortschritt des Achievements bei. Follower von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 100,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "es_ES": "Obtén 100 000 seguidores en el Club. Solo cuentan los nuevos seguidores. El número inicial de amistades del juego en común no cuenta para el progreso de los logros. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Cumulez 100 000 abonnés dans le Club. Seuls les nouveaux abonnés sont comptabilisés. Le nombre initial d'amis mutuels en jeu n'est pas pris en compte dans la progression du succès. Les abonnements provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 100,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "in_ID": "Dapatkan 100.000 pengikut di Club. Sistem hanya menghitung pengikut baru. Teman dalam game yang saling mengikuti sejak awal tidak dihitung dalam progres pencapaian. Akun abnormal yang mengikutimu tidak akan dihitung.",
    "ja_JP": "Get 100,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ko_KR": "Get 100,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 100,000 Folllower di Kelab. Hanya Follower baharu yang akan dikira. Bilangan awal rakan yang mengikuti satu sama lain tidak diambil kira dalam kemajuan pencapaian. Sebarang Follow daripada akaun abnormal tidak dikira.",
    "pt_PT": "Obtenha 100.000 seguidores no Clube. Somente seguidores novos são contados. O número inicial de amigos mútuos no jogo não conta para o progresso da conquista. Seguidores com contas anormais não contam.",
    "ru_RU": "Наберите 100 000 подписчиков в клубе. Учитываются только новые подписчики. Взаимные друзья по игре, которые добавились изначально, не учитываются при получении достижения. Подписки, оформленные с подозрительных аккаунтов, не учитываются.",
    "th_TH": "มีผู้ติดตามในคลับครบ 100,000 คน โดยจะนับแค่ผู้ติดตามใหม่เท่านั้น สำหรับจำนวนเพื่อนในเกมร่วมกันเริ่มต้นจะไม่ถูกนับรวมในความก้าวหน้าของความสำเร็จ โดยจะไม่นับรวมการติดตามที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Kulüp'te 100.000 takipçiye ulaş. Sadece yeni takipçiler hesaba katılır. Başlangıçta birbirini takip eden oyun arkadaşları başarım hesaplamasında dikkate alınmaz. Anormal hesaplardan gerçekleştirilen takipler hesaba katılmaz.",
    "ur": "کلب میں 100,000 فالورز حاصل کریں۔ صرف نئے فالورز کو شمار کیا جاتا ہے۔ گیم کے باہمی دوستوں کی ابتدائی تعداد کامیابی کی پیشرفت میں شمار نہیں ہوتی۔ غیر معمولی اکاؤنٹس کے کوئی بھی فالوز شمار نہیں ہوتے۔",
    "uz": "Klubda 100 000 kuzatuvchi jalb qiling. Faqat yangi kuzatuvchilar hisobga olinadi. Bir-birini kuzatadigan do‘stlarning dastlabki soni yutuq rivoji uchun hisobga olinmaydi. Noodatiy akkauntlardan kuzatishlar hisobga olinmaydi.",
    "vi_VN": "Nhận 100,000 người theo dõi trong Câu Lạc Bộ. Chỉ tính người theo dõi mới. Số lượng bạn bè trò chơi theo dõi lẫn nhau ban đầu không được tính vào tiến trình thành tích. Những lượt theo dõi đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，累计获得100,000名关注者。仅统计新增关注者数量，初始互相关注的游戏好友数量不会进入成就进度。任何异常账号的关注行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_13": {
    "HK": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的帖子或異常的帳號點擊再重新導向行為均不會計入有效進度。透過在俱樂部發佈標記WOW作品主題標籤的帖子，前往作品詳情頁面的玩家總數達到1,000。",
    "TW": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的貼文或異常帳號的點按前往操作都不計入有效進度。經由在俱樂部發佈標記WOW作品主題標籤的貼文，前往作品詳情頁面的玩家總數達到1,000。",
    "ar_SA": "يجب أن يكون رمز العمل واضحًا في مقطع الفيديو. أي منشورات غير مرتبطة بالعمل أو عمليات إعادة توجيه من حسابات مشبوهة لن تُحتسب ضمن التقدم. أعد توجيه اللاعبين إلى صفحة تفاصيل العمل 1000 مرة من خلال المنشورات في النادي التي تحمل شارات أعمال وااو.",
    "de_DE": "Der Arbeitscode muss im Video klar erkennbar sein. Jegliche Posts, die keine Verbindung zur Arbeit haben oder Weiterleitungen von ungewöhnlichen Accounts, zählen nicht zum Fortschritt. Leite Spieler 1000-mal mithilfe von Club-Posts mit WOW-Arbeit-Tags zur Detailseite einer Arbeit weiter.",
    "en_US": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 1,000 times through Club posts with WOW creation tags.",
    "es_ES": "El código de creación debe estar visible en el video. Cualquier publicación que no esté relacionada con la creación o las redirecciones desde cuentas inusuales no contarán para el progreso. Redirecciona a los jugadores a la página de los detalles de la creación 1000 veces a través de las publicaciones con etiquetas de creación WOW.",
    "fr_FR": "Le code de création doit être clairement visible dans la vidéo. Tout message non lié à la création ou les redirections à partir de comptes douteux ne seront pas comptabilisés dans la progression. Redirigez les joueurs vers la page de présentation d'une création 1 000 fois par le biais de publications dans le Club avec des tags de création WOW.",
    "hi_IN": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 1,000 times through Club posts with WOW creation tags.",
    "in_ID": "Kode karya harus terlihat jelas di video. Postingan yang tidak terkait dengan karya atau berasal dari akun mencurigakan tidak akan dihitung dalam Progres. Arahkan pemain mengakses laman detail karya 1.000 kali melalui postingan Club dengan tag karya WOW.",
    "ja_JP": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 1,000 times through Club posts with WOW creation tags.",
    "ko_KR": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 1,000 times through Club posts with WOW creation tags.",
    "ms_MY": "Kod ciptaan mesti dapat dilihat dengan jelas dalam video. Sebarang siaran tidak berkaitan dengan ciptaan atau diubah hala daripada akaun tidak normal tidak akan dikira dalam Kemajuan. Halakan pemain ke halaman butiran ciptaan sebanyak 1,000 kali melalui siaran Kelab dengan tag ciptaan WOW.",
    "pt_PT": "O código da criação precisa estar claramente visível no vídeo. Publicações não relacionadas à criação ou redirecionamentos de contas anormais não contarão para o Progresso. Redirecione jogadores para a página de detalhes de uma criação 1.000 vezes através de publicações do Clube com tags de criação do MdM.",
    "ru_RU": "На видео должен быть хорошо виден код творения. Публикации, не имеющие отношения к творению или сделанные с подозрительных аккаунтов, не учитываются. Игроки должны перейти на страницу сведений о творении 1000 раз через публикации в клубе с использованием тегов «Мира чудес».",
    "th_TH": "โค้ดผลงานที่ปรากฏในวิดีโอจะต้องมองเห็นได้อย่างชัดเจน สำหรับโพสต์ใดๆ ก็ตามที่ไม่เกี่ยวข้องกับผลงานหรือเป็นการเปลี่ยนเส้นทางจากบัญชีที่มีความผิดปกติจะไม่ถูกนับรวมในความก้าวหน้า โดยพาผู้เล่นไปยังหน้ารายละเอียดผลงานรวม 1,000 ครั้ง ผ่านโพสต์คลับที่มาพร้อมแท็กผลงาน WOW",
    "tr_TR": "Eser kodu videoda net bir şekilde görülebilmelidir. Eser ile bağlantısız gönderiler ve anormal hesaplardan yapılan yönlendirmeler ilerlemeye katkıda bulunmaz. Kulüp'te WOW eser etiketiyle paylaşılan gönderiler aracılığıyla oyuncuları 1.000 kez bir eserin ayrıntılar sayfasına yönlendir.",
    "ur": "تخلیق کا کوڈ ویڈیو میں واضح طور پر نظر آنا چاہیئے۔ کوئی بھی پوسٹس جو تخلیق سے غیر متعلقہ ہوں یا غیر معمولی اکاؤنٹس سے ری ڈائریکٹ ہوتی ہوں پیشرفت میں شمار نہیں ہوں گی۔ ‏WOW تخلیق کے ٹیگز کے ساتھ کلب کی پوسٹس کے ذریعے پلیئرز کو تخلیق کی تفصیلات کے پیج پر 1,000 مرتبہ ری ڈائریکٹ کریں۔",
    "uz": "Videoda ijodiy ish kodi aniq ko‘rinishi kerak. Ijodiy ishga aloqador bo‘lmagan postlar yoki shubhali akkauntlardan qayta yo‘naltirishlar rivoj uchun hisobga olinmaydi. Klubda WOW ijodiy ish teglariga ega postlar orqali o‘yinchilarni ijodiy ish tafsilotlari sahifasiga 1000 marta yo‘naltiring.",
    "vi_VN": "Mã tác phẩm bắt buộc phải thể hiện rõ trong video. Những bài post không liên quan đến tác phẩm hoặc được chuyển tiếp từ những tài khoản bất thường sẽ không được tính vào Tiến Độ. Chuyển tiếp người chơi dến trang thông tin tác phẩm 1,000 lần thông qua gắn thẻ tác phẩm WOW vào những bài post trong Câu Lạc Bộ.",
    "zh_CN": "视频画面中必须出现清晰可见的作品代码，任何与该作品无关的帖子或者异常账号的点击跳转行为不会被计算为有效进度。通过在俱乐部发布带有WOW作品标签的帖子，跳转作品详情页的玩家总数达到1,000。"
  },
  "club_achievement_overview_condition_14": {
    "HK": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的帖子或異常的帳號點擊再重新導向行為均不會計入有效進度。透過在俱樂部發佈標記WOW作品主題標籤的帖子，前往作品詳情頁面的玩家總數達到10,000。",
    "TW": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的貼文或異常帳號的點按前往操作都不計入有效進度。經由在俱樂部發佈標記WOW作品主題標籤的貼文，前往作品詳情頁面的玩家總數達到10,000。",
    "ar_SA": "يجب أن يكون رمز العمل واضحًا في مقطع الفيديو. أي منشورات غير مرتبطة بالعمل أو عمليات إعادة توجيه من حسابات مشبوهة لن تُحتسب ضمن التقدم. أعد توجيه اللاعبين إلى صفحة تفاصيل العمل 10000 مرة من خلال المنشورات في النادي التي تحمل شارات أعمال وااو.",
    "de_DE": "Der Arbeitscode muss im Video klar erkennbar sein. Jegliche Posts, die keine Verbindung zur Arbeit haben oder Weiterleitungen von ungewöhnlichen Accounts, zählen nicht zum Fortschritt. Leite Spieler 10000-mal mithilfe von Club-Posts mit WOW-Arbeit-Tags zur Detailseite einer Arbeit weiter.",
    "en_US": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 10,000 times through Club posts with WOW creation tags.",
    "es_ES": "El código de creación debe estar visible en el video. Cualquier publicación que no esté relacionada con la creación o las redirecciones desde cuentas inusuales no contarán para el progreso. Redirecciona a los jugadores a la página de los detalles de la creación 10 000 veces a través de las publicaciones con etiquetas de creación WOW.",
    "fr_FR": "Le code de création doit être clairement visible dans la vidéo. Tout message non lié à la création ou les redirections à partir de comptes douteux ne seront pas comptabilisés dans la progression. Redirigez les joueurs vers la page de présentation d'une création 10 000 fois par le biais de publications dans le Club avec des tags de création WOW.",
    "hi_IN": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 10,000 times through Club posts with WOW creation tags.",
    "in_ID": "Kode karya harus terlihat jelas di video. Postingan yang tidak terkait dengan karya atau berasal dari akun mencurigakan tidak akan dihitung dalam Progres. Arahkan pemain mengakses laman detail karya 10.000 kali melalui postingan Club dengan tag karya WOW.",
    "ja_JP": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 10,000 times through Club posts with WOW creation tags.",
    "ko_KR": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 10,000 times through Club posts with WOW creation tags.",
    "ms_MY": "Kod ciptaan mesti dapat dilihat dengan jelas dalam video. Sebarang siaran tidak berkaitan dengan ciptaan atau diubah hala daripada akaun tidak normal tidak akan dikira dalam Kemajuan. Halakan pemain ke halaman butiran ciptaan sebanyak 10,000 kali melalui siaran Kelab dengan tag ciptaan WOW.",
    "pt_PT": "O código da criação precisa estar claramente visível no vídeo. Publicações não relacionadas à criação ou redirecionamentos de contas anormais não contarão para o Progresso. Redirecione jogadores para a página de detalhes de uma criação 10.000 vezes através de publicações do Clube com tags de criação do MdM.",
    "ru_RU": "На видео должен быть хорошо виден код творения. Публикации, не имеющие отношения к творению или сделанные с подозрительных аккаунтов, не учитываются. Игроки должны перейти на страницу сведений о творении 10 000 раз через публикации в клубе с использованием тегов «Мира чудес».",
    "th_TH": "โค้ดผลงานที่ปรากฏในวิดีโอจะต้องมองเห็นได้อย่างชัดเจน สำหรับโพสต์ใดๆ ก็ตามที่ไม่เกี่ยวข้องกับผลงานหรือเป็นการเปลี่ยนเส้นทางจากบัญชีที่มีความผิดปกติจะไม่ถูกนับรวมในความก้าวหน้า โดยพาผู้เล่นไปยังหน้ารายละเอียดผลงานรวม 10,000 ครั้ง ผ่านโพสต์คลับที่มาพร้อมแท็กผลงาน WOW",
    "tr_TR": "Eser kodu videoda net bir şekilde görülebilmelidir. Eser ile bağlantısız gönderiler ve anormal hesaplardan yapılan yönlendirmeler ilerlemeye katkıda bulunmaz. Kulüp'te WOW eser etiketiyle paylaşılan gönderiler aracılığıyla oyuncuları 10.000 kez bir eserin ayrıntılar sayfasına yönlendir.",
    "ur": "تخلیق کا کوڈ ویڈیو میں واضح طور پر نظر آنا چاہیئے۔ کوئی بھی پوسٹس جو تخلیق سے غیر متعلقہ ہوں یا غیر معمولی اکاؤنٹس سے ری ڈائریکٹ ہوں پیشرفت میں شمار نہیں ہوں گی۔ ‏WOW تخلیق کے ٹیگز کے ساتھ کلب کی پوسٹس کے ذریعے پلیئرز کو تخلیق کی تفصیلات کے پیج پر 10,000 مرتبہ ری ڈائریکٹ کریں۔",
    "uz": "Videoda ijodiy ish kodi aniq ko‘rinishi kerak. Ijodiy ishga aloqador bo‘lmagan postlar yoki shubhali akkauntlardan qayta yo‘naltirishlar rivoj uchun hisobga olinmaydi. Klubda WOW ijodiy ish teglariga ega postlar orqali o‘yinchilarni ijodiy ish tafsilotlari sahifasiga 10 000 marta yo‘naltiring.",
    "vi_VN": "Mã tác phẩm cần phải hiển thị rõ trên video. Bất kỳ bài viết nào không liên quan đến tác phẩm hoặc được chuyển tiếp từ những tài khoản bất thường sẽ không được tính vào Tiến Độ. Chuyển tiếp đến trang chi tiết tác phẩm 10,000 lần thông qua bài viết trên Câu Lạc Bộ bằng thẻ tác phẩm WOW.",
    "zh_CN": "视频画面中必须出现清晰可见的作品代码，任何与该作品无关的帖子或者异常账号的点击跳转行为不会被计算为有效进度。通过在俱乐部发布带有WOW作品标签的帖子，跳转作品详情页的玩家总数达到10,000。"
  },
  "club_achievement_overview_condition_15": {
    "HK": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的帖子或異常的帳號點擊再重新導向行為均不會計入有效進度。透過在俱樂部發佈標記WOW作品主題標籤的帖子，前往作品詳情頁面的玩家總數達到100,000。",
    "TW": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的貼文或異常帳號的點按前往操作都不計入有效進度。經由在俱樂部發佈標記WOW作品主題標籤的貼文，前往作品詳情頁面的玩家總數達到100,000。",
    "ar_SA": "يجب أن يكون رمز العمل واضحًا في مقطع الفيديو. أي منشورات غير مرتبطة بالعمل أو عمليات إعادة توجيه من حسابات مشبوهة لن تُحتسب ضمن التقدم. أعد توجيه اللاعبين إلى صفحة تفاصيل العمل 100000 مرة من خلال المنشورات في النادي التي تحمل شارات أعمال وااو.",
    "de_DE": "Der Arbeitscode muss im Video klar erkennbar sein. Jegliche Posts, die keine Verbindung zur Arbeit haben oder Weiterleitungen von ungewöhnlichen Accounts, zählen nicht zum Fortschritt. Leite Spieler 100000-mal mithilfe von Club-Posts mit WOW-Arbeit-Tags zur Detailseite einer Arbeit weiter.",
    "en_US": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100,000 times through Club posts with WOW creation tags.",
    "es_ES": "El código de creación debe estar visible en el video. Cualquier publicación que no esté relacionada con la creación o las redirecciones desde cuentas inusuales no contarán para el progreso. Redirecciona a los jugadores a la página de los detalles de la creación 100 000 veces a través de las publicaciones con etiquetas de creación WOW.",
    "fr_FR": "Le code de création doit être clairement visible dans la vidéo. Tout message non lié à la création ou les redirections à partir de comptes douteux ne seront pas comptabilisés dans la progression. Redirigez les joueurs vers la page de présentation d'une création 100 000 fois par le biais de publications dans le Club avec des tags de création WOW.",
    "hi_IN": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100,000 times through Club posts with WOW creation tags.",
    "in_ID": "Kode karya harus terlihat jelas di video. Postingan yang tidak terkait dengan karya atau berasal dari akun mencurigakan tidak akan dihitung dalam Progres. Arahkan pemain mengakses laman detail karya 100.000 kali melalui postingan Club dengan tag karya WOW.",
    "ja_JP": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100,000 times through Club posts with WOW creation tags.",
    "ko_KR": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100,000 times through Club posts with WOW creation tags.",
    "ms_MY": "Kod ciptaan mesti dapat dilihat dengan jelas dalam video. Sebarang siaran tidak berkaitan dengan ciptaan atau diubah hala daripada akaun tidak normal tidak akan dikira dalam Kemajuan. Halakan pemain ke halaman butiran ciptaan sebanyak 100,000 kali melalui siaran Kelab dengan tag ciptaan WOW.",
    "pt_PT": "O código da criação precisa estar claramente visível no vídeo. Publicações não relacionadas à criação ou redirecionamentos de contas anormais não contarão para o Progresso. Redirecione jogadores para a página de detalhes de uma criação 100.000 vezes através de publicações do Clube com tags de criação do MdM.",
    "ru_RU": "На видео должен быть хорошо виден код творения. Публикации, не имеющие отношения к творению или сделанные с подозрительных аккаунтов, не учитываются. Игроки должны перейти на страницу сведений о творении 100 000 раз через публикации в клубе с использованием тегов «Мира чудес».",
    "th_TH": "โค้ดผลงานที่ปรากฏในวิดีโอจะต้องมองเห็นได้อย่างชัดเจน สำหรับโพสต์ใดๆ ก็ตามที่ไม่เกี่ยวข้องกับผลงานหรือเป็นการเปลี่ยนเส้นทางจากบัญชีที่มีความผิดปกติจะไม่ถูกนับรวมในความก้าวหน้า โดยพาผู้เล่นไปยังหน้ารายละเอียดผลงานรวม 100,000 ครั้ง ผ่านโพสต์คลับที่มาพร้อมแท็กผลงาน WOW",
    "tr_TR": "Eser kodu videoda net bir şekilde görülebilmelidir. Eser ile bağlantısız gönderiler ve anormal hesaplardan yapılan yönlendirmeler ilerlemeye katkıda bulunmaz. Kulüp'te WOW eser etiketiyle paylaşılan gönderiler aracılığıyla oyuncuları 100.000 kez bir eserin ayrıntılar sayfasına yönlendir.",
    "ur": "تخلیق کا کوڈ ویڈیو میں واضح طور پر نظر آنا چاہیئے۔ کوئی بھی پوسٹس جو تخلیق سے غیر متعلقہ ہوں یا غیر معمولی اکاؤنٹس سے ری ڈائریکٹ ہوں پیشرفت میں شمار نہیں ہوں گی۔ ‏WOW تخلیق کے ٹیگز کے ساتھ کلب کی پوسٹس کے ذریعے پلیئرز کو تخلیق کی تفصیلات کے پیج پر 100,000 مرتبہ ری ڈائریکٹ کریں۔",
    "uz": "Videoda ijodiy ish kodi aniq ko‘rinishi kerak. Ijodiy ishga aloqador bo‘lmagan postlar yoki shubhali akkauntlardan qayta yo‘naltirishlar rivoj uchun hisobga olinmaydi. Klubda WOW ijodiy ish teglariga ega postlar orqali o‘yinchilarni ijodiy ish tafsilotlari sahifasiga 100 000 marta yo‘naltiring.",
    "vi_VN": "Mã tác phẩm cần phải hiển thị rõ trên video. Bất kỳ bài viết nào không liên quan đến tác phẩm hoặc được chuyển tiếp từ những tài khoản bất thường sẽ không được tính vào Tiến Độ. Chuyển tiếp đến trang chi tiết tác phẩm 100,000 lần thông qua bài viết trên Câu Lạc Bộ bằng thẻ tác phẩm WOW.",
    "zh_CN": "视频画面中必须出现清晰可见的作品代码，任何与该作品无关的帖子或者异常账号的点击跳转行为不会被计算为有效进度。通过在俱乐部发布带有WOW作品标签的帖子，跳转作品详情页的玩家总数达到100,000。"
  },
  "club_achievement_overview_condition_16": {
    "HK": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的帖子或異常的帳號點擊重新導向行為均不會計入有效進度。透過在俱樂部發佈標記WOW作品主題標籤的帖子，前往作品詳情頁面的玩家總數達到100。",
    "TW": "影片畫面中必須出現清晰可見的作品代碼，任何與該作品無關的貼文或異常帳號的點按前往操作都不計入有效進度。經由在俱樂部發佈標記WOW作品主題標籤的貼文，前往作品詳情頁面的玩家總數達到100。",
    "ar_SA": "يجب أن يكون رمز العمل واضحًا في مقطع الفيديو. أي منشورات غير مرتبطة بالعمل أو عمليات إعادة توجيه من حسابات مشبوهة لن تُحتسب ضمن التقدم. أعد توجيه اللاعبين إلى صفحة تفاصيل العمل 100 مرة من خلال المنشورات في النادي التي تحمل شارات أعمال وااو.",
    "de_DE": "Der Arbeitscode muss im Video klar erkennbar sein. Jegliche Posts, die keine Verbindung zur Arbeit haben oder Weiterleitungen von ungewöhnlichen Accounts, zählen nicht zum Fortschritt. Leite Spieler 100-mal mithilfe von Club-Posts mit WOW-Arbeit-Tags zur Detailseite einer Arbeit weiter.",
    "en_US": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100 times through Club posts with WOW creation tags.",
    "es_ES": "El código de creación debe estar visible en el video. Cualquier publicación que no esté relacionada con la creación o las redirecciones desde cuentas inusuales no contarán para el progreso. Redirecciona a los jugadores a la página de los detalles de la creación 100 veces a través de las publicaciones con etiquetas de creación WOW.",
    "fr_FR": "Le code de création doit être clairement visible dans la vidéo. Tout message non lié à la création ou les redirections à partir de comptes douteux ne seront pas comptabilisés dans la progression. Redirigez les joueurs vers la page de présentation d'une création 100 fois par le biais de publications dans le Club avec des tags de création WOW.",
    "hi_IN": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100 times through Club posts with WOW creation tags.",
    "in_ID": "Kode karya harus terlihat jelas di video. Postingan yang tidak terkait dengan karya atau berasal dari akun mencurigakan tidak akan dihitung dalam Progres. Arahkan pemain mengakses laman detail karya 100 kali melalui postingan Club dengan tag karya WOW.",
    "ja_JP": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100 times through Club posts with WOW creation tags.",
    "ko_KR": "The creation code must be clearly visible in the video. Any posts unrelated to the creation or redirects from abnormal accounts will not count towards Progress. Redirect players to a creation's details page 100 times through Club posts with WOW creation tags.",
    "ms_MY": "Kod ciptaan mesti dapat dilihat dengan jelas dalam video. Sebarang siaran tidak berkaitan dengan ciptaan atau diubah hala daripada akaun tidak normal tidak akan dikira dalam Kemajuan. Halakan pemain ke halaman butiran ciptaan sebanyak 100 kali melalui siaran Kelab dengan tag ciptaan WOW.",
    "pt_PT": "O código da criação precisa estar claramente visível no vídeo. Publicações não relacionadas à criação ou redirecionamentos de contas anormais não contarão para o Progresso. Redirecione jogadores para a página de detalhes de uma criação 100 vezes através de publicações do Clube com tags de criação do MdM.",
    "ru_RU": "На видео должен быть хорошо виден код творения. Публикации, не имеющие отношения к творению или сделанные с подозрительных аккаунтов, не учитываются. Игроки должны перейти на страницу сведений о творении 100 раз через публикации в клубе с использованием тегов «Мира чудес».",
    "th_TH": "โค้ดผลงานที่ปรากฏในวิดีโอจะต้องมองเห็นได้อย่างชัดเจน สำหรับโพสต์ใดๆ ก็ตามที่ไม่เกี่ยวข้องกับผลงานหรือเป็นการเปลี่ยนเส้นทางจากบัญชีที่มีความผิดปกติจะไม่ถูกนับรวมในความก้าวหน้า โดยพาผู้เล่นไปยังหน้ารายละเอียดผลงานรวม 100 ครั้ง ผ่านโพสต์คลับที่มาพร้อมแท็กผลงาน WOW",
    "tr_TR": "Eser kodu videoda net bir şekilde görülebilmelidir. Eser ile bağlantısız gönderiler ve anormal hesaplardan yapılan yönlendirmeler ilerlemeye katkıda bulunmaz. Kulüp'te WOW eser etiketiyle paylaşılan gönderiler aracılığıyla oyuncuları 100 kez bir eserin ayrıntılar sayfasına yönlendir.",
    "ur": "تخلیق کا کوڈ ویڈیو میں واضح طور پر نظر آنا چاہیئے۔ کوئی بھی پوسٹس جو تخلیق سے غیر متعلقہ ہوں یا غیر معمولی اکاؤنٹس سے ری ڈائریکٹ ہوں پیشرفت میں شمار نہیں ہوں گی۔ ‏WOW تخلیق کے ٹیگز کے ساتھ کلب کی پوسٹس کے ذریعے پلیئرز کو تخلیق کی تفصیلات کے پیج پر 100 مرتبہ ری ڈائریکٹ کریں۔",
    "uz": "Videoda ijodiy ish kodi aniq ko‘rinishi kerak. Ijodiy ishga aloqador bo‘lmagan postlar yoki shubhali akkauntlardan qayta yo‘naltirishlar rivoj uchun hisobga olinmaydi. Klubda WOW ijodiy ish teglariga ega postlar orqali o‘yinchilarni ijodiy ish tafsilotlari sahifasiga 100 marta yo‘naltiring.",
    "vi_VN": "Mã tác phẩm cần phải hiển thị rõ trên video. Bất kỳ bài viết nào không liên quan đến tác phẩm hoặc được chuyển tiếp từ những tài khoản bất thường sẽ không được tính vào Tiến Độ. Chuyển tiếp đến trang chi tiết tác phẩm 100 lần thông qua bài viết trên Câu Lạc Bộ bằng thẻ tác phẩm WOW.",
    "zh_CN": "视频画面中必须出现清晰可见的作品代码，任何与该作品无关的帖子或者异常账号的点击跳转行为不会被计算为有效进度。通过在俱乐部发布带有WOW作品标签的帖子，跳转作品详情页的玩家总数达到100。"
  },
  "club_achievement_overview_condition_6": {
    "HK": "在俱樂部內，帖文累積獲得讚好數目達到1,000。任何異常帳號的讚好不會計作有效進度。",
    "TW": "在俱樂部內，發文累計獲得按讚數達到1,000。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 1000 إعجاب إجمالاً من المنشورات في النادي. لن يتم احتساب أي إعجابات من حسابات غير طبيعية.",
    "de_DE": "Erhalte insgesamt 1000 LIKEs durch Beiträge im Club. LIKEs von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get a total of 1,000 LIKEs from posts in Club. Any LIKEs from abnormal accounts do not count.",
    "es_ES": "Obtén un total de 1000 ME GUSTA en publicaciones en el Club. No contarán los ME GUSTA de cuentas irregulares.",
    "fr_FR": "Obtenez un total de 1 000 LIKES sur vos billets dans le Club. Les LIKES provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get a total of 1,000 LIKEs from posts in Club. Any LIKEs from abnormal accounts do not count.",
    "in_ID": "Dapatkan total 1.000 LIKE dari postinganmu di Club. LIKE dari akun abnormal tidak akan dihitung.",
    "ja_JP": "Get a total of 1,000 LIKEs from posts in Club. Any LIKEs from abnormal accounts do not count.",
    "ko_KR": "Get a total of 1,000 LIKEs from posts in Club. Any LIKEs from abnormal accounts do not count.",
    "ms_MY": "Dapatkan sejumlah 1,000 LIKE daripada siaran di Kelab. Sebarang LIKE daripada akaun abnormal tidak dikira.",
    "pt_PT": "Receba um total de 1.000 CURTIDAs de publicações no Clube. CURTIDAs de contas anormais não contam.",
    "ru_RU": "Получите в общей сложности 1000 лайков к публикациям в клубе. Лайки от подозрительных аккаунтов не учитываются.",
    "th_TH": "ได้รับ 1,000 ไลก์ จากโพสต์ในสคลับ โดยจะไม่นับรวมไลก์ที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Kulüp'teki paylaşımlarına toplam 1.000 beğeni al. Anormal hesaplardan verilen beğeniler hesaba katılmaz.",
    "ur": "کلب میں پوسٹس سے کُل 1,000 لائیکس حاصل کریں۔ غیر معمولی اکاؤنٹس سے ملنے والے کوئی بھی لائیکس شمار نہیں ہوتے۔",
    "uz": "Klubdagi postlarda jami 1000 ta Layk oling. Noodatiy akkauntlardan bosilgan Layklar hisobga olinmaydi.",
    "vi_VN": "Các bài đăng trong Câu Lạc Bộ nhận tổng cộng 1,000 lượt THÍCH. Những lượt THÍCH đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，发帖累计获得的点赞数达到1,000。任何异常账号的点赞行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_7": {
    "HK": "在俱樂部內，累積獲得10,000名追蹤者。僅計算新增追蹤者人數，最初互相追蹤的遊戲好友人數不會計入成就進度。任何異常帳號的追蹤不會計作有效進度。",
    "TW": "在俱樂部內，累計獲得10,000名追蹤者。僅統計新增追蹤者數量，初始互相追蹤的遊戲好友數量不會計入成就進度。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 10 آلاف متابع في النادي. يُحتسب المتابعون الجدد فقط. لا يُحتسب العدد الأولي للأصدقاء في اللعبة ضمن تقدم الإنجاز. لن يتم احتساب أي متابعين من حسابات غير طبيعية.",
    "de_DE": "Erhalte 10000 Follower im Club. Es zählen nur neue Follower. Die anfängliche Anzahl bereits vorhandener Freunde trägt nicht zum Fortschritt des Achievements bei. Follower von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 10,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "es_ES": "Obtén 10 000 seguidores en el Club. Solo cuentan los nuevos seguidores. El número inicial de amistades del juego en común no cuenta para el progreso de los logros. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Cumulez 10 000 abonnés dans le Club. Seuls les nouveaux abonnés sont comptabilisés. Le nombre initial d'amis mutuels en jeu n'est pas pris en compte dans la progression du succès. Les abonnements provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 10,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "in_ID": "Dapatkan 10.000 pengikut di Club. Sistem hanya menghitung pengikut baru. Teman dalam game yang saling mengikuti sejak awal tidak dihitung dalam progres pencapaian. Akun abnormal yang mengikutimu tidak akan dihitung.",
    "ja_JP": "Get 10,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ko_KR": "Get 10,000 followers in Club. Only new followers are counted. The initial number of mutual game friends does not count toward achievement progress. Any follows from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 10,000 Folllower di Kelab. Hanya Follower baharu yang akan dikira. Bilangan awal rakan yang mengikuti satu sama lain tidak diambil kira dalam kemajuan pencapaian. Sebarang Follow daripada akaun abnormal tidak dikira.",
    "pt_PT": "Obtenha 10.000 seguidores no Clube. Somente seguidores novos são contados. O número inicial de amigos mútuos no jogo não conta para o progresso da conquista. Seguidores com contas anormais não contam.",
    "ru_RU": "Наберите 10 000 подписчиков в клубе. Учитываются только новые подписчики. Взаимные друзья по игре, которые добавились изначально, не учитываются при получении достижения. Подписки, оформленные с подозрительных аккаунтов, не учитываются.",
    "th_TH": "มีผู้ติดตามในคลับครบ 10,000 คน โดยจะนับแค่ผู้ติดตามใหม่เท่านั้น สำหรับจำนวนเพื่อนในเกมร่วมกันเริ่มต้นจะไม่ถูกนับรวมในความก้าวหน้าของความสำเร็จ โดยจะไม่นับรวมการติดตามที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Kulüp'te 10.000 takipçiye ulaş. Sadece yeni takipçiler hesaba katılır. Başlangıçta birbirini takip eden oyun arkadaşları başarım hesaplamasında dikkate alınmaz. Anormal hesaplardan gerçekleştirilen takipler hesaba katılmaz.",
    "ur": "کلب میں 10,000 فالورز حاصل کریں۔ صرف نئے فالورز کو شمار کیا جاتا ہے۔ گیم کے باہمی دوستوں کی ابتدائی تعداد کامیابی کی پیشرفت میں شمار نہیں ہوتی۔ غیر معمولی اکاؤنٹس کے کوئی بھی فالوز شمار نہیں ہوتے۔",
    "uz": "Klubda 10 000 kuzatuvchi jalb qiling. Faqat yangi kuzatuvchilar hisobga olinadi. Bir-birini kuzatadigan do‘stlarning dastlabki soni yutuq rivoji uchun hisobga olinmaydi. Noodatiy akkauntlardan kuzatishlar hisobga olinmaydi.",
    "vi_VN": "Nhận 10,000 người theo dõi trong Câu Lạc Bộ. Chỉ tính người theo dõi mới. Số lượng bạn bè trò chơi theo dõi lẫn nhau ban đầu không được tính vào tiến trình thành tích. Những lượt theo dõi đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，累计获得10,000名关注者。仅统计新增关注者数量，初始互相关注的游戏好友数量不会进入成就进度。任何异常账号的关注行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_8": {
    "HK": "在俱樂部內，在日曆月內發表的評論獲讚好達200，每月更新可重複完成。任何異常帳號的讚好不會計作有效進度。",
    "TW": "在俱樂部內，當月發表的評論獲得按讚數達到200。任務每月更新，可重複完成。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 200 إعجاب من التعليقات في النادي في شهر ميلادي. يمكن إكمالها كل شهر. لن يتم احتساب أي إعجابات من حسابات غير طبيعية.",
    "de_DE": "Erhalte 200 LIKEs durch Kommentare im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden. LIKEs von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "es_ES": "Obtén 200 ME GUSTA en comentarios en el Club en un mes calendario. Se puede completar cada mes. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Obtenez 200 LIKES sur vos commentaires dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois. Les LIKES provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "in_ID": "Dapatkan 200 LIKE dari komentarmu di Club dalam satu bulan kalender. Bisa dilakukan setiap bulan. LIKE dari akun abnormal tidak akan dihitung.",
    "ja_JP": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "ko_KR": "Get 200 LIKEs from comments in Club in a calendar month. Can be completed every month. Any LIKEs from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 200 LIKE daripada komen di Kelab dalam sebulan. Boleh diselesaikan setiap bulan. Sebarang LIKE daripada akaun abnormal tidak dikira.",
    "pt_PT": "Receba 200 CURTIDAs de comentários no Clube em um mesmo mês. Pode ser concluída a cada mês. CURTIDAs de contas anormais não contam.",
    "ru_RU": "Получите 200 лайков за комментарии в клубе в течение календарного месяца. Можно достигать каждый месяц. Лайки от подозрительных аккаунтов не учитываются.",
    "th_TH": "ได้รับ 200 ไลก์ จากคอมเมนท์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน สามารถบรรลุได้ทุกเดือน โดยจะไม่นับรวมไลก์ที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki yorumlarına 200 beğeni al. Her ay tamamlanabilir. Anormal hesaplardan verilen beğeniler hesaba katılmaz.",
    "ur": "کیلنڈر مہینے میں کلب میں کمنٹس سے 200 لائیکس حاصل کریں۔ ہر مہینے مکمل کیا جا سکتا ہے۔ غیر معمولی اکاؤنٹس سے ملنے والے کوئی بھی لائیکس شمار نہیں ہوتے۔",
    "uz": "Bir kalendar oyi ichida klubdagi fikrlarda 200 ta Layk oling. Har oyda bajarilishi mumkin. Noodatiy akkauntlardan bosilgan Layklar hisobga olinmaydi.",
    "vi_VN": "Các bình luận trong Câu Lạc Bộ nhận tổng cộng 200 lượt THÍCH trong tháng. Có thể hoàn thành mỗi tháng. Những lượt THÍCH đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，自然月发表的评论获赞达到200，每月更新可重复完成。任何异常账号的点赞行为不会被计算为有效进度。"
  },
  "club_achievement_overview_condition_9": {
    "HK": "在俱樂部內，在日曆月內發佈帖文獲得的禮物人氣值達到10萬，每月更新可重複完成。任何異常帳號的送禮不會計作有效進度。",
    "TW": "在俱樂部內，當月發文獲得的禮物人氣值達到10萬。任務每月更新，可重複完成。所有異常帳號的按讚不會計算至有效進度。",
    "ar_SA": "احصل على 100 ألف شعبية من هدايا المنشورات في النادي في شهر ميلادي. يمكن إكمالها كل شهر. لن يتم احتساب أي هدايا من حسابات غير طبيعية.",
    "de_DE": "Erhalte 100000 Beliebtheit durch Geschenke im Club innerhalb eines Kalendermonats. Kann jeden Monat abgeschlossen werden. Geschenke von ungewöhnlichen Accounts zählen nicht.",
    "en_US": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month. Any gifts from abnormal accounts do not count.",
    "es_ES": "Obtén 100 000 de Popularidad en regalos por tus publicaciones en el Club en un mes calendario. Se puede completar cada mes. No cuentan los seguidores de cuentas irregulares.",
    "fr_FR": "Obtenez 100 000 de popularité grâce à des cadeaux pour vos billets dans le Club au cours d'un mois calendaire. Peut être accompli chaque mois. Les cadeaux provenant de comptes suspects ne sont pas pris en compte.",
    "hi_IN": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month. Any gifts from abnormal accounts do not count.",
    "in_ID": "Dapatkan 100.000 Popularitas dari hadiah untuk postinganmu di Club dalam satu bulan kalender. Bisa dilakukan setiap bulan. Hadiah dari akun abnormal tidak akan dihitung.",
    "ja_JP": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month. Any gifts from abnormal accounts do not count.",
    "ko_KR": "Get 100,000 Popularity from gifts for posts in Club in a calendar month. Can be completed every month. Any gifts from abnormal accounts do not count.",
    "ms_MY": "Dapatkan 100,000 Populariti daripada hadiah untuk siaran di Kelab dalam sebulan. Boleh diselesaikan setiap bulan. Sebarang hadiah daripada akaun abnormal tidak dikira.",
    "pt_PT": "Receba 100.000 de Popularidade de presentes por publicações no Clube em um mesmo mês. Pode ser concluída a cada mês. Presentes de contas anormais não contam.",
    "ru_RU": "Получите 100 000 ед. популярности от подарков за публикации в клубе в течение календарного месяца. Можно достигать каждый месяц. Подарки от подозрительных аккаунтов не учитываются.",
    "th_TH": "รับความนิยมครบ 100,000 จากของขวัญสำหรับโพสต์ในคลับภายในระยะเวลาหนึ่งเดือนตามปฏิทิน สามารถบรรลุได้ทุกเดือน โดยจะไม่นับรวมการส่งของขวัญที่มาจากบัญชีที่มีความผิดปกติ",
    "tr_TR": "Bir takvim ayı içinde Kulüp'teki gönderiler için hediyelerden 100.000 Popülerlik kazan. Her ay tamamlanabilir. Anormal hesaplardan elde edilen hediyeler hesaba katılmaz.",
    "ur": "کلب میں پوسٹس کے گفٹس سے ایک کیلنڈر مہینے میں 100,000 مقبولیت حاصل کریں۔ ہر مہینے مکمل کیا جا سکتا ہے۔ غیر معمولی اکاؤنٹس سے ملنے والے کوئی بھی گفٹس شمار نہیں ہوتے۔",
    "uz": "Bir kalendar oyida Klubdagi postlar uchun hadyalar orqali 100 000 Mashhurlikka ega bo‘ling. Har oyda bajarilishi mumkin. Noodatiy akkauntlardan yuborilgan hadyalar hisobga olinmaydi.",
    "vi_VN": "Các bài đăng trong Câu Lạc Bộ nhận được quà tặng với tổng cộng 100,000 Điểm Nổi Tiếng trong tháng. Có thể hoàn thành mỗi tháng. Những phần quà đến từ tài khoản bất thường sẽ không được tính.",
    "zh_CN": "在俱乐部内，自然月发帖获得的礼物人气值达到10万，每月更新可重复完成。任何异常账号的送礼行为不会被计算为有效进度。"
  },
  "club_achievement_overview_know": {
    "HK": "知道了",
    "TW": "知道了",
    "ar_SA": "حسنًا",
    "de_DE": "Alles klar",
    "en_US": "Got It",
    "es_ES": "Entendido",
    "fr_FR": "OK",
    "hi_IN": "Got It",
    "in_ID": "Mengerti",
    "ja_JP": "Got It",
    "ko_KR": "Got It",
    "ms_MY": "Faham",
    "pt_PT": "Obtive",
    "ru_RU": "Ясно",
    "th_TH": "รับทราบ",
    "tr_TR": "Tamam",
    "ur": "سمجھ آ گئی",
    "uz": "Tushunarli",
    "vi_VN": "Đã Rõ",
    "zh_CN": "知道了"
  },
  "club_achievement_overview_monthly": {
    "HK": "每月更新",
    "TW": "每月更新",
    "ar_SA": "يُحدّث شهريًا",
    "de_DE": "Monatliche Updates",
    "en_US": "Updates Monthly",
    "es_ES": "Se actualiza cada mes",
    "fr_FR": "Mise à jour mensuelle",
    "hi_IN": "Updates Monthly",
    "in_ID": "Pembaruan Bulanan",
    "ja_JP": "Updates Monthly",
    "ko_KR": "Updates Monthly",
    "ms_MY": "Dikemas Kini Setiap Bulan",
    "pt_PT": "Atualiza Mensalmente",
    "ru_RU": "Ежемесячные обновления",
    "th_TH": "อัปเดตประจำเดือน",
    "tr_TR": "Aylık Olarak Güncellenir",
    "ur": "ماہانہ اپ ڈیٹ ہوتا ہے",
    "uz": "Oylik yangilanishlar",
    "vi_VN": "Cập Nhật Hàng Tháng",
    "zh_CN": "每月更新"
  },
  "club_achievement_overview_open": {
    "HK": "展開",
    "TW": "展開",
    "ar_SA": "توسيع",
    "de_DE": "Ausklappen",
    "en_US": "Expand",
    "es_ES": "Expandir",
    "fr_FR": "Afficher",
    "hi_IN": "Expand",
    "in_ID": "Selengkapnya",
    "ja_JP": "Expand",
    "ko_KR": "Expand",
    "ms_MY": "Kembang",
    "pt_PT": "Expandir",
    "ru_RU": "Развернуть",
    "th_TH": "ขยาย",
    "tr_TR": "Genişlet",
    "ur": "‏توسیع کریں",
    "uz": "Yoyish",
    "vi_VN": "Mở rộng",
    "zh_CN": "展开"
  },
  "club_achievement_overview_pop_condition_title": {
    "HK": "達成條件",
    "TW": "達成條件",
    "ar_SA": "المتطلبات",
    "de_DE": "Anforderungen",
    "en_US": "Requirements",
    "es_ES": "Requisitos",
    "fr_FR": "Conditions",
    "hi_IN": "Requirements",
    "in_ID": "Persyaratan",
    "ja_JP": "Requirements",
    "ko_KR": "Requirements",
    "ms_MY": "Syarat",
    "pt_PT": "Requisitos",
    "ru_RU": "Требования",
    "th_TH": "เงื่อนไข",
    "tr_TR": "Gereksinimler",
    "ur": "تقاضے",
    "uz": "Talablar",
    "vi_VN": "Yêu cầu",
    "zh_CN": "达成条件"
  },
  "club_achievement_overview_pop_monthly": {
    "HK": "每月1日（UTC+0）更新",
    "TW": "每月1日（UTC+0）更新",
    "ar_SA": "يُحدّث في بداية كل شهر (بالتوقيت العالمي+0)",
    "de_DE": "Wird jeweils am 1. Tag des Monats aktualisiert (UTC±0)",
    "en_US": "Updates on the 1st of every month (UTC +0)",
    "es_ES": "Se actualiza el primer día de cada mes (UTC +0)",
    "fr_FR": "Mise à jour le 1er de chaque mois (UTC +0)",
    "hi_IN": "Updates on the 1st of every month (UTC +0)",
    "in_ID": "Diperbarui pada tanggal 1 setiap bulannya (UTC+0)",
    "ja_JP": "Updates on the 1st of every month (UTC +0)",
    "ko_KR": "Updates on the 1st of every month (UTC +0)",
    "ms_MY": "Dikemas kini pada hari pertama bagi setiap bulan (UTC +0)",
    "pt_PT": "Atualiza no dia 1 de cada mês (UTC +0)",
    "ru_RU": "Обновления 1 числа каждого месяца (UTC+0)",
    "th_TH": "อัปเดตทุกวันที่ 1 ของเดือน (UTC +0)",
    "tr_TR": "Her ayın 1'inde güncellenir (UTC +0)",
    "ur": "ہر مہینے کی 1 تاریخ کو اپ ڈیٹ ہوتا ہے (UTC +0)",
    "uz": "Har oyning 1-kunidagi yangilanishlar (UTC +0)",
    "vi_VN": "Cập nhật vào ngày 1 hàng tháng (UTC +0)",
    "zh_CN": "每月1号UTC 0更新"
  },
  "club_achievement_overview_pop_ok": {
    "HK": "已達到",
    "TW": "已達到",
    "ar_SA": "مُنجز",
    "de_DE": "Erreicht",
    "en_US": "Achieved",
    "es_ES": "Logrado",
    "fr_FR": "Accompli",
    "hi_IN": "Achieved",
    "in_ID": "Tercapai",
    "ja_JP": "Achieved",
    "ko_KR": "Achieved",
    "ms_MY": "Dicapai",
    "pt_PT": "Conquistou",
    "ru_RU": "Получено",
    "th_TH": "สำเร็จแล้ว",
    "tr_TR": "Başarıyla Alındı",
    "ur": "حاصل ہو گیا",
    "uz": "Erishildi",
    "vi_VN": "Đã đạt",
    "zh_CN": "已达到"
  },
  "club_achievement_overview_pop_reward_title": {
    "HK": "獎勵",
    "TW": "獎勵",
    "ar_SA": "المكافآت",
    "de_DE": "Belohnungen",
    "en_US": "Rewards",
    "es_ES": "Recompensas",
    "fr_FR": "Récompenses",
    "hi_IN": "Rewards",
    "in_ID": "Hadiah",
    "ja_JP": "Rewards",
    "ko_KR": "Rewards",
    "ms_MY": "Ganjaran",
    "pt_PT": "Recompensas",
    "ru_RU": "Награды",
    "th_TH": "รางวัล",
    "tr_TR": "Ödüller",
    "ur": "‏انعامات",
    "uz": "Mukofotlar",
    "vi_VN": "Phần Thưởng",
    "zh_CN": "奖励"
  },
  "club_achievement_overview_pop_title": {
    "HK": "詳情",
    "TW": "詳情",
    "ar_SA": "التفاصيل",
    "de_DE": "Details",
    "en_US": "Details",
    "es_ES": "Detalles",
    "fr_FR": "Détails",
    "hi_IN": "Details",
    "in_ID": "Detail",
    "ja_JP": "Details",
    "ko_KR": "Details",
    "ms_MY": "Butiran",
    "pt_PT": "Detalhes",
    "ru_RU": "Детали",
    "th_TH": "รายละเอียด",
    "tr_TR": "Ayrıntılar",
    "ur": "تفصیلات",
    "uz": "Tafsilotlar",
    "vi_VN": "Chi Tiết",
    "zh_CN": "详情"
  },
  "club_achievement_overview_reward_10": {
    "HK": "頭像框：俱樂部頭像框（30天）",
    "TW": "頭像框：俱樂部頭像框（30天）",
    "ar_SA": "إطار الصورة الرمزية: إطار الصورة الرمزية للنادي (30 يومًا)",
    "de_DE": "Avatar-Rahmen: Club-Avatar-Rahmen (30d)",
    "en_US": "Avatar Frame: Club Avatar Frame (30d)",
    "es_ES": "Marco de Avatar: Marco de Avatar del Club (30 d)",
    "fr_FR": "Cadre d'avatar : Cadre d'avatar du Club (30 j)",
    "hi_IN": "Avatar Frame: Club Avatar Frame (30d)",
    "in_ID": "Bingkai Avatar: Bingkai Avatar Club (30h)",
    "ja_JP": "Avatar Frame: Club Avatar Frame (30d)",
    "ko_KR": "Avatar Frame: Club Avatar Frame (30d)",
    "ms_MY": "Bingkai Avatar: Bingkai Avatar Kelab (30h)",
    "pt_PT": "Moldura de Avatar: Moldura de Avatar do Clube (30 d)",
    "ru_RU": "Рамка клуба (30 д.)",
    "th_TH": "กรอบรูป: กรอบรูปคลับ (30D)",
    "tr_TR": "Avatar Çerçevesi: Kulüp Avatar Çerçevesi (30g)",
    "ur": "اواتار کا فریم: کلب کا اواتار کا فریم (30 دن)",
    "uz": "Avatar hoshiyasi: Klub avatar hoshiyasi (30 kun)",
    "vi_VN": "Khung Ảnh Đại Diện: Khung Ảnh Đại Diện Câu Lạc Bộ (30 Ngày)",
    "zh_CN": "头像框:CLUB头像框(30天)"
  },
  "club_achievement_overview_reward_11": {
    "HK": "稱號：俱樂部名人（永久）",
    "TW": "稱號：俱樂部名人（永久）",
    "ar_SA": "لقب: نجم النادي (دائم)",
    "de_DE": "Titel: Club-Star (Permanent)",
    "en_US": "Title: Club Star (Permanent)",
    "es_ES": "Título: Estrella del Club (permanente)",
    "fr_FR": "Titre : Star du Club (permanent)",
    "hi_IN": "Title: Club Star (Permanent)",
    "in_ID": "Gelar: Club Star (Permanen)",
    "ja_JP": "Title: Club Star (Permanent)",
    "ko_KR": "Title: Club Star (Permanent)",
    "ms_MY": "Gelaran: Bintang Kelab (Kekal)",
    "pt_PT": "Título: Estrela do Clube (Permanente)",
    "ru_RU": "Титул «Звезда клуба» (постоянный)",
    "th_TH": "ฉายา: Club Star (ถาวร)",
    "tr_TR": "Unvan: Kulübün Yıldızı (Kalıcı)",
    "ur": "ٹائٹل: کلب کا ستارہ (مستقل)",
    "uz": "Unvon: Klub yulduzi (doimiy)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部名人 (永久)"
  },
  "club_achievement_overview_reward_12": {
    "HK": "稱號：俱樂部超級巨星（永久）",
    "TW": "稱號：俱樂部超級巨星（永久）",
    "ar_SA": "لقب: نجم النادي المتألق (دائم)",
    "de_DE": "Titel: Club-Megastar (Permanent)",
    "en_US": "Title: Club Megastar (Permanent)",
    "es_ES": "Título: Megaestrella del Club (permanente)",
    "fr_FR": "Titre : Mégastar du Club (permanent)",
    "hi_IN": "Title: Club Megastar (Permanent)",
    "in_ID": "Gelar: Club Megastar (Permanen)",
    "ja_JP": "Title: Club Megastar (Permanent)",
    "ko_KR": "Title: Club Megastar (Permanent)",
    "ms_MY": "Gelaran: Bintang Mega Kelab (Kekal)",
    "pt_PT": "Título: Megaestrela do Clube (Permanente)",
    "ru_RU": "Титул «Мегазвезда клуба» (постоянный)",
    "th_TH": "ฉายา: Club Megastar (ถาวร)",
    "tr_TR": "Unvan: Kulübün Megastarı (Kalıcı)",
    "ur": "ٹائٹل: کلب کا میگاسٹار (مستقل)",
    "uz": "Unvon: Klub megayulduzi (doimiy)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Siêu Cấp Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部超级巨星 (永久)"
  },
  "club_achievement_overview_reward_13": {
    "HK": "稱號：WOW新手鑑賞家（永久）",
    "TW": "稱號：WOW新手鑑賞家（永久）",
    "ar_SA": "اللقب: مُقيِّم وااو مبتدئ (دائم)",
    "de_DE": "Titel: WOW-Gutachteranfänger (permanent)",
    "en_US": "Title: WOW Rookie Appraiser (Permanent)",
    "es_ES": "Título: Valuador Novato de WOW (permanente)",
    "fr_FR": "Titre : Appréciateur débutant WOW (permanent)",
    "hi_IN": "Title: WOW Rookie Appraiser (Permanent)",
    "in_ID": "Gelar: WOW Rookie Appraiser (Permanen)",
    "ja_JP": "Title: WOW Rookie Appraiser (Permanent)",
    "ko_KR": "Title: WOW Rookie Appraiser (Permanent)",
    "ms_MY": "Gelaran: Penilai Baharu WOW (Kekal)",
    "pt_PT": "Titulo: Avaliador Novato do MdM (Permanente)",
    "ru_RU": "Титул: Новичок-оценщик «Мира чудес» (постоянный)",
    "th_TH": "ฉายา: WOW นักประเมินมือใหม่ (ถาวร)",
    "tr_TR": "Unvan: WOW Çaylak Eksper (Kalıcı)",
    "ur": "ٹائٹل: WOW اناڑی تخمینہ کار (مستقل)",
    "uz": "Unvon: WOW Tajribasiz baholovchi (doimiy)",
    "vi_VN": "Danh Hiệu: Nhà Thẩm Định Tập Sự WOW (Vĩnh Viễn)",
    "zh_CN": "称号：WOW新手鉴赏家（永久）"
  },
  "club_achievement_overview_reward_14": {
    "HK": "稱號：WOW資深鑑賞家（永久）",
    "TW": "稱號：WOW資深鑑賞家（永久）",
    "ar_SA": "اللقب: مُقيِّم وااو متمرس (دائم)",
    "de_DE": "Titel: WOW-Gutachterveteran (permanent)",
    "en_US": "Title: WOW Veteran Appraiser (Permanent)",
    "es_ES": "Título: Valuador Veterano de WOW (permanente)",
    "fr_FR": "Titre : Appréciateur chevronné WOW (permanent)",
    "hi_IN": "Title: WOW Veteran Appraiser (Permanent)",
    "in_ID": "Gelar: WOW Veteran Appraiser (Permanen)",
    "ja_JP": "Title: WOW Veteran Appraiser (Permanent)",
    "ko_KR": "Title: WOW Veteran Appraiser (Permanent)",
    "ms_MY": "Gelaran: Penilai Veteran WOW (Kekal)",
    "pt_PT": "Titulo: Avaliador Veterano do MdM (Permanente)",
    "ru_RU": "Титул: Ветеран-оценщик «Мира чудес» (постоянный)",
    "th_TH": "ฉายา: WOW นักประเมินมืออาชีพ (ถาวร)",
    "tr_TR": "Unvan: WOW Emektar Eksper (Kalıcı)",
    "ur": "ٹائٹل: WOW تجربہ کار تخمینہ کار (مستقل)",
    "uz": "Unvon: WOW Veteran baholovchi (doimiy)",
    "vi_VN": "Danh Hiệu: Nhà Thẩm Định Kỳ Cựu WOW (Vĩnh Viễn)",
    "zh_CN": "称号：WOW资深鉴赏家（永久）"
  },
  "club_achievement_overview_reward_15": {
    "HK": "稱號：WOW頂級鑑賞家（永久）",
    "TW": "稱號：WOW頂級鑑賞家（永久）",
    "ar_SA": "اللقب: مُقيِّم وااو متميز (دائم)",
    "de_DE": "Titel: WOW-Gutachterelite (permanent)",
    "en_US": "Title: WOW Elite Appraiser (Permanent)",
    "es_ES": "Título: Valuador de Élite de WOW (permanente)",
    "fr_FR": "Titre : Appréciateur ultime WOW (permanent)",
    "hi_IN": "Title: WOW Elite Appraiser (Permanent)",
    "in_ID": "Gelar: WOW Elite Appraiser (Permanen)",
    "ja_JP": "Title: WOW Elite Appraiser (Permanent)",
    "ko_KR": "Title: WOW Elite Appraiser (Permanent)",
    "ms_MY": "Gelaran: Penilai Elit WOW (Kekal)",
    "pt_PT": "Titulo: Avaliador Elite do MdM (Permanente)",
    "ru_RU": "Титул: Легендарный оценщик «Мира чудес» (постоянный)",
    "th_TH": "ฉายา: WOW นักประเมินขั้นสูง (ถาวร)",
    "tr_TR": "Unvan: WOW Elit Eksper (Kalıcı)",
    "ur": "ٹائٹل: WOW ایلیٹ تخمینہ کار (مستقل)",
    "uz": "Unvon: WOW Elita baholovchi (doimiy)",
    "vi_VN": "Danh Hiệu: Nhà Thẩm Định Ưu Tú WOW (Vĩnh Viễn)",
    "zh_CN": "称号：WOW顶级鉴赏家（永久）"
  },
  "club_achievement_overview_reward_16": {
    "HK": "頭像框：WOW鑑賞家專屬頭像框（30天）",
    "TW": "頭像框：WOW鑑賞家專屬頭像框（30天）",
    "ar_SA": "إطار الصورة الرمزية: إطار صورة مُقيِّم وااو الرمزية الحصري (30 ي)",
    "de_DE": "Avatar-Rahmen: Exklusiver WOW-Gutachter-Avatar-Rahmen (30d)",
    "en_US": "Avatar Frame: WOW Appraiser Exclusive Avatar Frame (30d)",
    "es_ES": "Marco de Avatar: Marco de Avatar Exclusivo de Valuador de WOW (30 d)",
    "fr_FR": "Cadre d'avatar : Cadre d'avatar exclusif Appréciateur WOW (30 j)",
    "hi_IN": "Avatar Frame: WOW Appraiser Exclusive Avatar Frame (30d)",
    "in_ID": "Bingkai Avatar: Bingkai Avatar Eksklusif WOW Appraiser (30h)",
    "ja_JP": "Avatar Frame: WOW Appraiser Exclusive Avatar Frame (30d)",
    "ko_KR": "Avatar Frame: WOW Appraiser Exclusive Avatar Frame (30d)",
    "ms_MY": "Bingkai Avatar: Bingkai Avatar Eksklusif Penilai WOW (30h)",
    "pt_PT": "Moldura de Avatar: Moldura de Avatar Exclusiva de Avaliador do MdM (30 d)",
    "ru_RU": "Рамка: Эксклюзивная рамка оценщика «Мира чудес» (30 д.)",
    "th_TH": "กรอบรูป: กรอบรูปพิเศษสำหรับนักประเมิน WOW (30D)",
    "tr_TR": "Avatar Çerçevesi: WOW Eksperi Özel Avatar Çerçevesi (30g)",
    "ur": "اواتار کا فریم: WOW تخمینہ کار کا خصوصی اواتار کا فریم (30 دن)",
    "uz": "Avatar hoshiyasi: WOW Baholovchi ekskluziv avatar hoshiyasi (30 kun)",
    "vi_VN": "Khung Ảnh Đại Diện: Khung Ảnh Đại Diện Độc Quyền Nhà Thẩm Định WOW (30 ngày)",
    "zh_CN": "头像框：WOW鉴赏家专属头像框（30天）"
  },
  "club_achievement_overview_reward_6": {
    "HK": "稱號：俱樂部新星（永久）",
    "TW": "稱號：俱樂部新星（永久）",
    "ar_SA": "لقب: نجم النادي الصاعد (دائم)",
    "de_DE": "Titel: Aufsteigender Clubstern (Permanent)",
    "en_US": "Title: Club Rising Star (Permanent)",
    "es_ES": "Título: Estrella en Ascenso del Club (permanente)",
    "fr_FR": "Titre : Étoile montante du Club (permanent)",
    "hi_IN": "Title: Club Rising Star (Permanent)",
    "in_ID": "Gelar: Club Rising Star (Permanen)",
    "ja_JP": "Title: Club Rising Star (Permanent)",
    "ko_KR": "Title: Club Rising Star (Permanent)",
    "ms_MY": "Gelaran: Bintang Baharu Kelab (Kekal)",
    "pt_PT": "Título: Estrela em Ascensão do Clube (Permanente)",
    "ru_RU": "Титул «Восходящая звезда клуба» (постоянный)",
    "th_TH": "ฉายา: ดาวรุ่งคลับ (ถาวร)",
    "tr_TR": "Unvan: Kulübün Yükselen Yıldızı (Kalıcı)",
    "ur": "ٹائٹل: کلب کا ابھرتا ستارہ (مستقل)",
    "uz": "Unvon: Klub porlayotgan yulduzi (doimiy)",
    "vi_VN": "Danh Hiệu: Ngôi Sao Mới Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部新星 (永久)"
  },
  "club_achievement_overview_reward_7": {
    "HK": "稱號：俱樂部萬人迷（永久）",
    "TW": "稱號：俱樂部萬人迷（永久）",
    "ar_SA": "لقب: نجم النادي اللامع (دائم)",
    "de_DE": "Titel: Club-Superstar (Permanent)",
    "en_US": "Title: Club Superstar (Permanent)",
    "es_ES": "Título: Superestrella del Club (permanente)",
    "fr_FR": "Titre : Superstar du Club (permanent)",
    "hi_IN": "Title: Club Superstar (Permanent)",
    "in_ID": "Gelar: Club Superstar (Permanen)",
    "ja_JP": "Title: Club Superstar (Permanent)",
    "ko_KR": "Title: Club Superstar (Permanent)",
    "ms_MY": "Gelaran: Bintang Super Kelab (Kekal)",
    "pt_PT": "Título: Superestrela do Clube (Permanente)",
    "ru_RU": "Титул «Суперзвезда клуба» (постоянный)",
    "th_TH": "ฉายา: ซุปเปอร์สตาร์คลับ (ถาวร)",
    "tr_TR": "Unvan: Kulübün Süperstarı (Kalıcı)",
    "ur": "ٹائٹل: کلب کا سپر اسٹار (مستقل)",
    "uz": "Unvon: Klub superyulduzi (doimiy)",
    "vi_VN": "Danh Hiệu: Siêu Sao Câu Lạc Bộ (Vĩnh Viễn)",
    "zh_CN": "称号:俱乐部万人迷(永久)"
  },
  "club_achievement_overview_reward_8": {
    "HK": "稱號：妙語連珠（30天）",
    "TW": "稱號：妙語連珠（30天）",
    "ar_SA": "لقب: الفصيح (30 يومًا)",
    "de_DE": "Titel: Silberzunge (30d)",
    "en_US": "Title: Silver-Tongued (30d)",
    "es_ES": "Título: Elocuente (30 d)",
    "fr_FR": "Titre : Langue d'argent (30 j)",
    "hi_IN": "Title: Silver-Tongued (30d)",
    "in_ID": "Title: Silver-Tongued (30h)",
    "ja_JP": "Title: Silver-Tongued (30d)",
    "ko_KR": "Title: Silver-Tongued (30d)",
    "ms_MY": "Gelaran: Fasih (30h)",
    "pt_PT": "Titulo: Eloquente (30 d)",
    "ru_RU": "Титул «Красноречие» (30 д.)",
    "th_TH": "ฉายา: ลิ้นทองคำ (30D)",
    "tr_TR": "Unvan: Söz Sahibi (30g)",
    "ur": "ٹائٹل: خوش گفتار (30 دن)",
    "uz": "Unvon: Tili burro (30 kun)",
    "vi_VN": "Danh Hiệu: Ăn Nói Khéo Léo (30 Ngày)",
    "zh_CN": "称号:妙语连珠 (30天)"
  },
  "club_achievement_overview_reward_9": {
    "HK": "資訊卡：魅力十足（30天）",
    "TW": "資訊卡：魅力十足（30天）",
    "ar_SA": "بطاقة المعلومات: الفتنة الطاغية (30 يومًا)",
    "de_DE": "Infokarte: Zauberhafter Reiz (30d)",
    "en_US": "Info Card: Charming Allure (30d)",
    "es_ES": "Tarjeta de Información: Entorno Encantador (30 d)",
    "fr_FR": "Carte d'infos : Atmosphère charmante (30 j)",
    "hi_IN": "Info Card: Charming Allure (30d)",
    "in_ID": "Kartu Info: Charming Allure (30h)",
    "ja_JP": "Info Card: Charming Allure (30d)",
    "ko_KR": "Info Card: Charming Allure (30d)",
    "ms_MY": "Kad Maklumat: Godaan Anggun (30h)",
    "pt_PT": "Cartão de Informações: Atração Encantadora (30 d)",
    "ru_RU": "Карта данных «Очаровательный шарм» (30 д.)",
    "th_TH": "บัตรข้อมูล: เจ้าเสน่ห์ (30D)",
    "tr_TR": "Bilgi Kartı: Büyüleyen Cazibe (30g)",
    "ur": "معلوماتی کارڈ: پرکشش رغبت (30 دن)",
    "uz": "Axborot kartasi: Maftunkor joziba (30 kun)",
    "vi_VN": "Thẻ Thông Tin: Vô Cùng Quyến Rũ (30 Ngày)",
    "zh_CN": "信息卡:魅力十足(30天)"
  },
  "club_achievement_overview_tips": {
    "HK": "完成成就以解鎖稱號、頭像框等獎勵，點擊查看",
    "TW": "完成成就以解鎖稱號、頭像框等獎勵，點按查看",
    "ar_SA": "أكمل الإنجازات لتحرير مكافآت سخية مثل الألقاب وإطارات الصور الرمزية! اضغط لمزيد من التفاصيل.",
    "de_DE": "Schließe Achievements ab, um Belohnungen freizuschalten, wie z. B. Titel und Avatar-Rahmen! Zum Ansehen tippen.",
    "en_US": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "es_ES": "¡Completa logros para desbloquear recompensas como Títulos y Marcos de Avatar! Toca para ver más.",
    "fr_FR": "Accomplissez des succès pour débloquer des récompenses uniques ! Appuyez pour plus de détails.",
    "hi_IN": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "in_ID": "Raih prestasi untuk membuka hadiah, seperti Gelar dan Bingkai Avatar! Tekan untuk melihat.",
    "ja_JP": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "ko_KR": "Complete achievements to unlock rewards like Titles and Avatar Frames! Tap to view.",
    "ms_MY": "Lengkapkan pencapaian untuk membuka ganjaran seperti Gelaran dan Bingkai Avatar! Ketik untuk melihat.",
    "pt_PT": "Obtenha conquistas para desbloquear recompensas como Títulos e Molduras de Avatar! Toque para ver.",
    "ru_RU": "Получайте достижения, чтобы открыть такие награды как титулы и рамки аватара! Нажмите, чтобы узнать подробнее.",
    "th_TH": "บรรลุความสำเร็จเพื่อปลดล็อครางวัล อย่างเช่น ฉายาและกรอบรูป! แตะเพื่อดู",
    "tr_TR": "Unvan ve Avatar Çerçevesi gibi ödüllerin kilidini açmak için başarımları tamamla! Görüntülemek için dokun.",
    "ur": "ٹائٹلز اور اواتار کے فریمز جیسے انعامات کو ان لاک کرنے کے لیے کامیابیوں کو مکمل کریں! دیکھنے کے لیے ٹیپ کریں۔",
    "uz": "Unvonlar va avatar hoshiyasi kabi mukofotlarni ochish uchun yutuqlarni toʻldiring! Koʻrish uchun tegining.",
    "vi_VN": "Hoàn thành thành tích để mở khóa thưởng Danh Hiệu và Khung Ảnh Đại Diện! Nhấn để xem.",
    "zh_CN": "完成成就解锁称号、头像框等奖励，点击查看"
  },
  "club_achievement_overview_title": {
    "HK": "我的成就",
    "TW": "我的成就",
    "ar_SA": "إنجازاتي",
    "de_DE": "Meine Achievements",
    "en_US": "My Achievements",
    "es_ES": "Mis logros",
    "fr_FR": "Mes succès",
    "hi_IN": "My Achievements",
    "in_ID": "Prestasi Saya",
    "ja_JP": "My Achievements",
    "ko_KR": "My Achievements",
    "ms_MY": "Pencapaian Saya",
    "pt_PT": "Minhas Conquistas",
    "ru_RU": "Мои достижения",
    "th_TH": "ความสำเร็จของฉัน",
    "tr_TR": "Başarımlarım",
    "ur": "میری کامیابیاں",
    "uz": "Yutuqlarim",
    "vi_VN": "Thành Tích Của Tôi",
    "zh_CN": "我的成就"
  },
  "club_achievement_personal": {
    "HK": "個人成就",
    "TW": "個人成就",
    "ar_SA": "إنجازات شخصية",
    "de_DE": "Persönliche Achievements",
    "en_US": "Personal Achievements",
    "es_ES": "Personal Achievements",
    "fr_FR": "Succès personnels",
    "hi_IN": "Personal Achievements",
    "in_ID": "Prestasi Pribadi",
    "ja_JP": "Personal Achievements",
    "ko_KR": "Personal Achievements",
    "ms_MY": "Pencapaian Peribadi",
    "pt_PT": "Conquistas Pessoais",
    "ru_RU": "Персональные достижения",
    "th_TH": "ความสำเร็จส่วนตัว",
    "tr_TR": "Kişisel Başarımlar",
    "ur": "ذاتی کامیابیاں",
    "uz": "Shaxsiy yutuqlar",
    "vi_VN": "Thành Tích Cá Nhân",
    "zh_CN": "个人成就"
  },
  "club_achievement_policy": {
    "HK": "隱藏我的成就資訊",
    "TW": "隱藏我的成就資訊",
    "ar_SA": "إخفاء إنجازاتي عن الآخرين",
    "de_DE": "Meine Achievements vor anderen verbergen",
    "en_US": "Hide my achievements from others",
    "es_ES": "Ocultar mis logros de otros",
    "fr_FR": "Ne pas montrer mes succès aux autres",
    "hi_IN": "Hide my achievements from others",
    "in_ID": "Sembunyikan prestasi dari orang lain",
    "ja_JP": "Hide my achievements from others",
    "ko_KR": "Hide my achievements from others",
    "ms_MY": "Sembunyikan pencapaian saya daripada pemain lain",
    "pt_PT": "Esconder minhas conquistas dos outros",
    "ru_RU": "Скрыть мои достижения от остальных",
    "th_TH": "ซ่อนความสำเร็จของฉันจากคนอื่นๆ",
    "tr_TR": "Başarımlarımı diğerlerinden gizle",
    "ur": "میری کامیابیاں دوسروں سے چھپائیں",
    "uz": "Yutuqlarimni boshqalardan yashiring",
    "vi_VN": "Ẩn Thông Tin Thành Tích",
    "zh_CN": "隐藏我的成就信息"
  },
  "club_rank_setting_cancel": {
    "HK": "取消",
    "TW": "取消",
    "ar_SA": "إلغاء",
    "de_DE": "Abbrechen",
    "en_US": "Cancel",
    "es_ES": "Cancelar",
    "fr_FR": "Annuler",
    "hi_IN": "Cancel",
    "in_ID": "Batalkan",
    "ja_JP": "Cancel",
    "ko_KR": "Cancel",
    "ms_MY": "Batal",
    "pt_PT": "Cancelar",
    "ru_RU": "Отмена",
    "th_TH": "ยกเลิก",
    "tr_TR": "İptal",
    "ur": "منسوخ کریں",
    "uz": "Bekor qilish",
    "vi_VN": "Hủy",
    "zh_CN": "取消"
  },
  "club_rank_setting_confirm": {
    "HK": "確認",
    "TW": "確定",
    "ar_SA": "تأكيد",
    "de_DE": "Bestätigen",
    "en_US": "Confirm",
    "es_ES": "Aceptar",
    "fr_FR": "Confirmer",
    "hi_IN": "Confirm",
    "in_ID": "Konfirmasi",
    "ja_JP": "Confirm",
    "ko_KR": "Confirm",
    "ms_MY": "Sahkan",
    "pt_PT": "Confirmar",
    "ru_RU": "Подтвердить",
    "th_TH": "ยืนยัน",
    "tr_TR": "Onayla",
    "ur": "تصدیق کریں",
    "uz": "Tasdiqlash",
    "vi_VN": "Đồng ý",
    "zh_CN": "确认"
  },
  "club_rank_setting_title": {
    "HK": "私隱設定",
    "TW": "隱私設定",
    "ar_SA": "إعدادات الخصوصية",
    "de_DE": "Datenschutz-Einstellungen",
    "en_US": "Privacy Settings",
    "es_ES": "Configuración de privacidad",
    "fr_FR": "Paramètres de confidentialité",
    "hi_IN": "Privacy Settings",
    "in_ID": "Pengaturan Privasi",
    "ja_JP": "Privacy Settings",
    "ko_KR": "Privacy Settings",
    "ms_MY": "Tetapan Privasi",
    "pt_PT": "Ajustes de Privacidade",
    "ru_RU": "Настройки конфиденциальности",
    "th_TH": "ตั้งค่าความเป็นส่วนตัว",
    "tr_TR": "Gizlilik Ayarları",
    "ur": "پرائیویسی سیٹنگز",
    "uz": "Maxfiylik sozlamalari",
    "vi_VN": "Cài Đặt Quyền Riêng Tư",
    "zh_CN": "隐私设置"
  }
}